import { Tag } from '@/types';
import { LocalizedText } from '../LocalizedText/LocalizedText';
import styles from './EventTag.module.scss';

export interface EventTagProps {
  tag: Tag;
}

export const EventTag = ({ tag }: EventTagProps) => {
  return (
    <li className={styles.tag}>
      <a href={tag.link}>
        <LocalizedText text={tag.text} />
      </a>
    </li>
  );
};
